export default __webpack_public_path__ + "static/media/onboardedDummyImage.8afcca24.png";